<as-split
  unit="pixel"
  gutterAriaLabel="Tamanho da lista de tópicos"
  [direction]="isBelowMd() ? 'vertical' : 'horizontal'"
  (dragEnd)="onSidebarDragEnd($event)"
>
  <as-split-area class="sidebar" [size]="300" [minSize]="180">
    <h2 class="sidebar-title">Ajuda</h2>

    <cdk-tree
      #tree
      class="help-tree"
      aria-label="Tópicos da ajuda"
      [dataSource]="topicos"
      [childrenAccessor]="childrenAccessor"
      [trackBy]="trackById"
    >
      <cdk-nested-tree-node
        *cdkTreeNodeDef="let node"
        class="node"
        [isExpandable]="false"
        [cdkTreeNodeTypeaheadLabel]="node.text"
        [attr.aria-current]="current?.id === node.id ? 'page' : null"
        (activation)="loadItem(node, 'arvore')"
      >
        <div class="node-row" [class.active]="current?.id === node.id" [attr.data-topico]="node.id">
          <span class="twisty" aria-hidden="true"></span>
          <span class="node-text">{{ node.text }}</span>
        </div>
      </cdk-nested-tree-node>

      <cdk-nested-tree-node
        *cdkTreeNodeDef="let node; when: hasChildren"
        class="node"
        [isExpandable]="true"
        [cdkTreeNodeTypeaheadLabel]="node.text"
        [attr.aria-current]="current?.id === node.id ? 'page' : null"
        (activation)="tree.expand(node); loadItem(node, 'arvore')"
      >
        <div class="node-row" [class.active]="current?.id === node.id" [attr.data-topico]="node.id">
          <button
            type="button"
            class="twisty"
            tabindex="-1"
            aria-hidden="true"
            cdkTreeNodeToggle
            (click)="$event.stopPropagation()"
          >
            <svg-icon src="assets/mdi/chevron-right.svg" [class.open]="tree.isExpanded(node)" />
          </button>
          <span class="node-text">{{ node.text }}</span>
        </div>

        <div class="node-children" role="group" [hidden]="!tree.isExpanded(node)">
          <ng-container cdkTreeNodeOutlet />
        </div>
      </cdk-nested-tree-node>
    </cdk-tree>
  </as-split-area>

  <as-split-area>
    <article class="help-content" aria-live="off">
      @if (markdown !== undefined) {
        <markdown #conteudo [data]="markdown" (ready)="onContentReady()" />
      }
    </article>
  </as-split-area>
</as-split>
